import {
    get,
    getWithoutRetry,
    postWithoutRetry,
} from './client';

/**
 * 
 * @param {*} data 
 * @returns 
 */
export default function loginFetch(data) {
    return postWithoutRetry('authenticate', data, {
        skipAuth: true,
    });
}

/**
 * 
 * @returns 
 */
export function getUser() {
    return get('user');
}

export function refresh() {
    return getWithoutRetry('refresh');
}
